import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

$(document).ready(function () {
  if ($('.js-acf-loop').length) {
    $('.js-acf-loop').each(function () {
      const $container = $(this);
      const $swiperEl = $container.find('.swiper');

      new Swiper($swiperEl[0], {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 24,

        navigation: {
          nextEl: $container.find('.swiper-button-next')[0],
          prevEl: $container.find('.swiper-button-prev')[0],
        },

        pagination: {
          el: $container.find('.swiper-pagination')[0],
          clickable: true,
        },

        breakpoints: {
          1020: { slidesPerView: 2 },
          1440: { slidesPerView: 3 },
        },
      });
    });
  }
});
